<template>
  <div class="Label-staff">
    <div class="label-top">
      <el-tag
        class="tree-input"
        title="选择员工"
        :closable="this.searchMenNames.length === 0 ? false : true"
        @close="searchCloseTag"
        type="medium"
        effect="plain"
        @click="clickAddMember(true)"
      >
        <span v-if="searchMenNames.length === 0">选择员工</span>
        <span v-for="(item, index) in searchMenNames" :key="index"
          >{{ item.name }}<span v-if="searchMenNames.length > 1">,</span></span
        >
      </el-tag>
      <el-input
        placeholder="使用场景"
        suffix-icon="el-icon-search"
        size="mini"
        @blur="searchFn"
        @clear="searchFn"
        v-model="formInline.sceneName"
        clearable
        style="width: 180px; margin-right: 10px"
      >
      </el-input>
      <div class="count-btns">
        <span class="btns-title">客户添加统计</span>
        <span
          v-for="(item, index) in countBtns"
          :key="item.id"
          class="count-btn"
          :class="item.class"
          @click="sortBtnHandle(item, index)"
          >{{ item.text }}</span
        >
      </div>
      <el-date-picker
        v-model="searchSelectTime"
        size="mini"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="~"
        start-placeholder="统计时间"
        end-placeholder="统计时间"
        @change="selectTime"
        clearable
        style="width: 240px; margin-right: 10px"
        :default-time="['00:00:00', '23:59:59']"
      >
      </el-date-picker>
    </div>
    <el-row :gutter="20">
      <el-col>
        <el-table
          ref="table"
          size="small"
          :data="tableData"
          fit
          highlight-current-row
          align="center"
          :header-cell-style="{ background: '#F9F9F9' }"
          height="calc(100vh - 235px)"
          style="font-size: 13px"
          :default-sort="this.defaultSort"
          @sort-change="sortChange"
          show-summary
          :summary-method="getTotal"
        >
          <!-- v-loading="loading"
          element-loading-text="拼命加载中" -->
          <el-table-column type="index" min-width="50"> </el-table-column>
          <el-table-column
            prop="userName"
            label="使用员工"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="sceneName"
            label="使用场景"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="cusCumulative"
            sortable
            label="累计客户数"
            min-width="120"
            :sort-orders="['descending', 'ascending', null]"
            :sort-method="sortMethod"
          ></el-table-column>
          <el-table-column
            prop="cusUp"
            sortable
            label="新增客户数"
            min-width="120"
            :sort-orders="['descending', 'ascending', null]"
            :sort-method="sortMethod"
          ></el-table-column>
          <el-table-column
            prop="cusDown"
            sortable
            label="流失客户数"
            min-width="120"
            :sort-orders="['descending', 'ascending', null]"
            :sort-method="sortMethod"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            min-width="120"
          ></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <Pagination
      v-bind:childMsg="pageparm"
      :pageSizes="pageSizes"
      @callBack="callBack"
    ></Pagination>
    <!-- 添加人员树 -->
    <!-- <AddMemberView 
      :title="title"
      :dialogVisibleTree="dialogVisibleTree" 
      :currentSelectMember='currentSelectMember' 
      @closeTree='closeTree' 
      @clickSubmitTree='clickSubmitTree'
    ></AddMemberView> -->
    <StaffTree
      :title="title"
      :dialogVisibleTree="dialogVisibleTree"
      :currentSelectMember="currentSelectMember"
      @closeTree="closeTree"
      @clickSubmitTree="clickSubmitTree"
    ></StaffTree>
  </div>
</template>
<script>
import AddMemberView from "./components/addMember.vue";
import StaffTree from "@/components/staffTree/staffTree.vue";
import { codeCount } from "@/api/activeCode/activeCode.js";

export default {
  name: "CusChatSupervise",
  components: {
    // AddMemberView,
    StaffTree,
  },
  data() {
    return {
      tableHeight: 500,
      title: "选择使用员工",
      searchSelectTime: [], //时间框
      tableData: [],
      // loading: false,
      defaultSort: { prop: "cusCumulative", order: "descending" },
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 20,
      },
      formInline: {
        pageNum: 1,
        pageSize: 20,
        sceneName: "",
        mark: 7,
        userIdList: [],
        cusCumulativeSort: "cusCumDesc", //累计客户数排序【string，非必传】
        cusDownSort: "", //新增客户数排序 【string，非必传】
        cusUpSort: "", //流失客户数排序 【string，非必传】
        startTime: "",
        endTime: "",
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      countBtns: [
        { text: "昨日", id: "zuori", class: "", val: -1 },
        { text: "近7日", id: "near7", class: "btnSelect", val: 7 },
        { text: "近30日", id: "near30", class: "", val: 30 },
      ],
      dialogVisibleTree: false, //弹窗开关
      currentSelectMember: [], //组件中要显示-选中的成员
      searchMenNames: [], //当前 搜索框-选中的成员
      currentIdName: [],
      markLength: 0,
    };
  },
  created() {
    this.getCodeCount();
  },
  watch: {
    // markLength(val){
    //   if(this.markLength == this.currentSelectMember.length){
    //     this.getCodeCount()
    //   }
    // }
  },
  methods: {
    sortMethod(a, b, type) {
      //-1 降序 1 升序
      let time1 = new Date(a.createTime).getTime();
      let time2 = new Date(b.createTime).getTime();
      if (this.defaultSort.order == "ascending") {
        //升序
        if (a[this.defaultSort.prop] == b[this.defaultSort.prop]) {
          return time2 - time1;
        } else {
          return 1;
        }
      } else if (this.defaultSort.order == "descending") {
        //降序
        if (a[this.defaultSort.prop] == b[this.defaultSort.prop]) {
          return time1 - time2;
        } else {
          return -1;
        }
      }
    },
    //分页回调
    callBack(parm) {
      this.formInline.pageNum = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.getCodeCount();
    },
    //排序条件改变
    sortChange(val) {
      this.defaultSort = { prop: val.prop, order: val.order };
      this.formInline.cusCumulativeSort = "";
      this.formInline.cusDownSort = "";
      this.formInline.cusUpSort = "";
      switch (val.prop) {
        case "cusCumulative":
          if (val.order == "ascending") {
            this.formInline.cusCumulativeSort = "cusCumAsc";
          } else if (val.order == "descending") {
            this.formInline.cusCumulativeSort = "cusCumDesc";
          }
          break;
        case "cusUp":
          if (val.order == "ascending") {
            this.formInline.cusUpSort = "cusUpAsc";
          } else if (val.order == "descending") {
            this.formInline.cusUpSort = "cusUpDesc";
          }
          break;
        case "cusDown":
          if (val.order == "ascending") {
            this.formInline.cusDownSort = "cusDownAsc";
          } else if (val.order == "descending") {
            this.formInline.cusDownSort = "cusDownDesc";
          }
          break;
        default:
          break;
      }
      this.getCodeCount();
    },
    //获取活码统计数据
    getCodeCount() {
      // this.loading = true
      codeCount(this.formInline, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            // this.loading = false
            this.tableData = res.data.result;
            this.pageparm.total = res.data.total;
            this.$nextTick(() => {
              this.$refs.table.doLayout();
            });
          }
        })
        .catch((err) => {});
    },
    getTotal(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (
          column.property === "cusCumulative" ||
          column.property === "cusUp" ||
          column.property === "cusDown"
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    sortBtnHandle(item, index) {
      if (this.countBtns[index].class == "") {
        //选中
        this.countBtns.map((v) => {
          v.class = "";
        });
        this.countBtns[index].class = "btnSelect";
        this.formInline.mark = item.val;
        this.searchSelectTime = [];
        this.formInline.pageNum = 1;
        this.getCodeCount();
      }
    },
    //选择时间
    selectTime(val) {
      if (val == null) {
        this.formInline.startTime = "";
        this.formInline.endTime = "";
        this.formInline.mark = 7;
        this.countBtns.map((v) => {
          if (v.val == 7) {
            v.class = "btnSelect";
          } else {
            v.class = "";
          }
        });
      } else {
        this.formInline.mark = "";
        this.countBtns.map((v) => {
          v.class = "";
        });
        this.formInline.startTime = val[0];
        this.formInline.endTime = val[1];
      }
      this.formInline.pageNum = 1;
      this.getCodeCount();
    },
    // 搜索使用场景
    searchFn(val) {
      this.formInline.pageNum = 1;
      this.getCodeCount();
    },
    //打开树
    clickAddMember() {
      this.dialogVisibleTree = true;
    },
    // 树操作
    closeTree(val) {
      this.dialogVisibleTree = false;
    },
    //对象数组去重(根据userId去重)
    getArrSet(Arr, id) {
      var obj = {};
      const arrays = Arr.reduce((setArr, item) => {
        obj[item[id]] ? "" : (obj[item[id]] = true && setArr.push(item));
        return setArr;
      }, []);
      return arrays;
    },
    // 搜索-添加成员---清空
    searchCloseTag() {
      this.searchMenNames = [];
      this.currentSelectMember = [];
      this.formInline.userIdList = [];
      // this.markLength = 0
      this.formInline.pageNum = 1;
      this.getCodeCount();
    },
    //添加人弹窗确认回调
    clickSubmitTree(val) {
      this.currentSelectMember = val.currentMember;
      this.formInline.pageNum = 1;
      this.formInline.userIdList = [];
      // this.markLength = 0
      this.searchMenNames = val.currentIdName;
      val.sendArray.forEach((item) => {
        this.formInline.userIdList.push(item.userId);
      });
      this.getCodeCount();
      this.dialogVisibleTree = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.Label-staff {
  .label-top {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  /deep/.tree-input {
    margin-right: 10px;
    width: 200px;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    .el-icon-close {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 5px;
    }
  }
  .Pagination {
    // margin-top: 20px;
  }
  .el-table {
    overflow: visible !important;
  }
  .count-btns {
    display: inline-block;
    font-size: 14px;
    color: #666666;
    white-space: nowrap;
    margin-right: 10px;
    cursor: pointer;
    .btns-title {
      margin-right: 5px;
    }
    .btnSelect {
      background: #eceaea;
    }
    .count-btn {
      padding: 5px 8px;
      border-radius: 6px;
      border: 1px solid #dcdfe6;
      margin: 0 2px;
      font-size: 12px;
    }
  }
  .dialog-label {
    .el-dialog {
      max-height: 800px;
      overflow-y: scroll;
    }
    .el-dialog__body {
      padding-bottom: 10px;
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
  .el-tag--plain {
    border-color: #dcdfe6;
    color: #c0c4cf;
  }
}
</style>
